module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-onigiri@3x-dd2b04110d7f6f8a89e5981f0b29367e.png";